// export default Gallery;
import React, { useState, useEffect } from "react";
import gallery1 from "../assets/images/anh1.jpg";
import gallery2 from "../assets/images/anh2.jpg";
import gallery3 from "../assets/images/anh3.jpg";
import gallery4 from "../assets/images/anh4.jpg";
import gallery5 from "../assets/images/anh5.jpg";
import gallery6 from "../assets/images/anh6.jpg";
import "./Gallery.css";

function Gallery() {
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [isLoaded, setIsLoaded] = useState(false);

  // Animation when component mounts
  useEffect(() => {
    setIsLoaded(true);
  }, []);

  // Filter gallery items
  const filterGallery = (filter) => {
    setSelectedFilter(filter);
  };

  return (
    <div
      id="wedding-gallery"
      className="wedding-gallery-section wedding-section-padding"
    >
      {/* Decorative elements */}
      <div className="wedding-decorative-elements">
        <div className="wedding-flower wedding-flower-top-left">🌸</div>
        <div className="wedding-flower wedding-flower-top-right">🌷</div>
        <div className="wedding-flower wedding-flower-bottom-left">🌹</div>
        <div className="wedding-flower wedding-flower-bottom-right">💐</div>
      </div>

      <div className="wedding-container">
        <div className="wedding-row" id="wedding-row">
          <div className="wedding-col-full wedding-mb-30">
            <div className="wedding-title-wrapper">
              <span className="wedding-title-meta">
                <span className="wedding-icon">💖</span> Bộ sưu tập{" "}
                <span className="wedding-icon">💖</span>
              </span>
              <h2 className="wedding-title">Kỷ niệm của chúng tôi</h2>
              <div className="wedding-title-divider">
                <span className="wedding-divider-icon">💍</span>
              </div>
            </div>

            {/* Filter buttons */}
            {/* <div className="wedding-gallery-filter-buttons">
              <button
                className={`wedding-filter-btn ${
                  selectedFilter === "all" ? "wedding-active" : ""
                }`}
                onClick={() => filterGallery("all")}
              >
                Tất cả <span className="wedding-filter-icon">📸</span>
              </button>
              <button
                className={`wedding-filter-btn ${
                  selectedFilter === "ceremony" ? "wedding-active" : ""
                }`}
                onClick={() => filterGallery("ceremony")}
              >
                Lễ cưới <span className="wedding-filter-icon">👰</span>
              </button>
              <button
                className={`wedding-filter-btn ${
                  selectedFilter === "party" ? "wedding-active" : ""
                }`}
                onClick={() => filterGallery("party")}
              >
                Tiệc cưới <span className="wedding-filter-icon">🥂</span>
              </button>
            </div> */}
          </div>
        </div>
      </div>

      <div className="wedding-container">
        <div
          className={`wedding-gallery-grid ${isLoaded ? "wedding-loaded" : ""}`}
        >
          <div
            className={`wedding-gallery-item wedding-ceremony ${
              selectedFilter === "all" || selectedFilter === "ceremony"
                ? "wedding-show"
                : "wedding-hide"
            }`}
          >
            <div className="wedding-gallery-box">
              <div className="wedding-gallery-img">
                <img
                  src={gallery1}
                  className="wedding-img-fluid"
                  alt="Wedding ceremony photograph"
                />
                <div className="wedding-gallery-overlay">
                  <div className="wedding-gallery-icon">❤️</div>
                </div>
              </div>
              <div className="wedding-gallery-detail">
                {/* <h4>Lễ cưới tại nhà thờ</h4> */}
                <p>Khoảnh khắc thiêng liêng</p>
                <div className="wedding-gallery-date">05.04.2025</div>
              </div>
            </div>
          </div>

          <div
            className={`wedding-gallery-item wedding-party ${
              selectedFilter === "all" || selectedFilter === "party"
                ? "wedding-show"
                : "wedding-hide"
            }`}
          >
            <div className="wedding-gallery-box">
              <div className="wedding-gallery-img">
                <img
                  src={gallery2}
                  className="wedding-img-fluid"
                  alt="Wedding party photograph"
                />
                <div className="wedding-gallery-overlay">
                  <div className="wedding-gallery-icon">💑</div>
                </div>
              </div>
              <div className="wedding-gallery-detail">
                {/* <h4>Tiệc cưới vui vẻ</h4> */}
                <p>Khoảnh khắc lãng mạn</p>
                <div className="wedding-gallery-date">05.04.2025</div>
              </div>
            </div>
          </div>

          <div
            className={`wedding-gallery-item wedding-ceremony ${
              selectedFilter === "all" || selectedFilter === "ceremony"
                ? "wedding-show"
                : "wedding-hide"
            }`}
          >
            <div className="wedding-gallery-box">
              <div className="wedding-gallery-img">
                <img
                  src={gallery3}
                  className="wedding-img-fluid"
                  alt="Wedding ceremony photograph"
                />
                <div className="wedding-gallery-overlay">
                  <div className="wedding-gallery-icon">💍</div>
                </div>
              </div>
              <div className="wedding-gallery-detail">
                {/* <h4>Trao nhẫn cưới</h4> */}
                <p>Khoảnh khắc xúc động</p>
                <div className="wedding-gallery-date">05.04.2025</div>
              </div>
            </div>
          </div>

          <div
            className={`wedding-gallery-item wedding-party ${
              selectedFilter === "all" || selectedFilter === "party"
                ? "wedding-show"
                : "wedding-hide"
            }`}
          >
            <div className="wedding-gallery-box">
              <div className="wedding-gallery-img">
                <img
                  src={gallery4}
                  className="wedding-img-fluid"
                  alt="Wedding party photograph"
                />
                <div className="wedding-gallery-overlay">
                  <div className="wedding-gallery-icon">🎉</div>
                </div>
              </div>
              <div className="wedding-gallery-detail">
                {/* <h4>Khiêu vũ cùng nhau</h4> */}
                <p>Khoảnh khắc hạnh phúc</p>
                <div className="wedding-gallery-date">05.04.2025</div>
              </div>
            </div>
          </div>

          <div
            className={`wedding-gallery-item wedding-ceremony ${
              selectedFilter === "all" || selectedFilter === "ceremony"
                ? "wedding-show"
                : "wedding-hide"
            }`}
          >
            <div className="wedding-gallery-box">
              <div className="wedding-gallery-img">
                <img
                  src={gallery5}
                  className="wedding-img-fluid"
                  alt="Wedding ceremony photograph"
                />
                <div className="wedding-gallery-overlay">
                  <div className="wedding-gallery-icon">👰</div>
                </div>
              </div>
              <div className="wedding-gallery-detail">
                {/* <h4>Cô dâu xinh đẹp</h4> */}
                <p>Khoảnh khắc rạng rỡ</p>
                <div className="wedding-gallery-date">05.04.2025</div>
              </div>
            </div>
          </div>

          <div
            className={`wedding-gallery-item wedding-party ${
              selectedFilter === "all" || selectedFilter === "party"
                ? "wedding-show"
                : "wedding-hide"
            }`}
          >
            <div className="wedding-gallery-box">
              <div className="wedding-gallery-img">
                <img
                  src={gallery6}
                  className="wedding-img-fluid"
                  alt="Wedding party photograph"
                />
                <div className="wedding-gallery-overlay">
                  <div className="wedding-gallery-icon">🎂</div>
                </div>
              </div>
              <div className="wedding-gallery-detail">
                {/* <h4>Cắt bánh cưới</h4> */}
                <p>Khoảnh khắc ngọt ngào</p>
                <div className="wedding-gallery-date">05.04.2025</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Gallery;
